<script setup></script>
<template>
    <svg viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.43994 30.1757V20.0707H14.2994" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M32.2638 30.1757H4.19434" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.2993 30.1757V13.3341H22.1588" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M30.0181 6.59741H22.1587V30.1757H30.0181V6.59741Z" stroke="#F2CD59" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>